import { Controller } from '@hotwired/stimulus';

export default class DialogController extends Controller {
  static targets = ['modal'];
  declare readonly modalTarget: HTMLDialogElement;

  open() {
    if (!this.modalTarget.open) {
      this.modalTarget.showModal();
    }
  }

  // Close when clicking the backdrop (the area outside the dialog content box)
  backdropClose(event: MouseEvent) {
    const dialog = event.currentTarget as HTMLDialogElement;
    const rect = dialog.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      dialog.close();
    }
  }
}
